import React from 'react';
import {useDispatch} from "react-redux";
import { setIsReload } from "@legacy/stores/actions/companySwitcherActions";

const ReloadCompaniesLink = () => {
    const dispatch = useDispatch();

    return (
        <p>
            There was an error fetching the list of companies.
            <a
                href="#"
                onClick={() => {
                    dispatch(setIsReload(true));
                }}
            >Try again</a>
        </p>
    );
}

export default ReloadCompaniesLink;